import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineShoppingCart, AiOutlineClose } from 'react-icons/ai';
import { useNotification } from '../../context/NotificationContext';
import './NotificationToast.css';

const AUTO_DISMISS_MS = 5000;

function NotificationToast() {
  const { toasts, dismissToast } = useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    if (toasts.length === 0) return;

    const timers = toasts.map(toast =>
      setTimeout(() => dismissToast(toast.id), AUTO_DISMISS_MS)
    );

    return () => timers.forEach(clearTimeout);
  }, [toasts, dismissToast]);

  const handleClick = (orderId, toastId) => {
    dismissToast(toastId);
    navigate(`/admin/orders/${orderId}`);
  };

  if (toasts.length === 0) return null;

  return (
    <div className="notification-toast-container">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className="notification-toast"
          onClick={() => handleClick(toast.orderId, toast.id)}
        >
          <div className="notification-toast-icon">
            <AiOutlineShoppingCart size={20} />
          </div>
          <div className="notification-toast-content">
            <strong>새 주문 알림</strong>
            <span>{toast.message}</span>
          </div>
          <button
            className="notification-toast-close"
            onClick={(e) => {
              e.stopPropagation();
              dismissToast(toast.id);
            }}
          >
            <AiOutlineClose size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}

export default NotificationToast;
